import { useDispatch, useSelector } from "react-redux";
import { SOCKET, socketPairTopicPrefix } from "../constants/constants";
import { socket } from "../App";
import { useEffect } from "react";
import { setLastPrice, setLastTrade } from "../features/ats/atsSlice";

/**
 * Public market trade stream for the selected pair. Room join is centralized in
 * exchangePairRoomSocket (useExchangeRoomSync in Exchange).
 */
export const SocketHook = () => {
  const dispatch = useDispatch();
  const selectedPair = useSelector((state) => state?.ats?.selectedPair);

  useEffect(() => {
    if (!selectedPair?.pair_key) return undefined;

    const pairPrefix = socketPairTopicPrefix(selectedPair.pair_key);
    const tradeEvent = `${pairPrefix}${SOCKET.TRADE_BOOK}`;
    const lastTradePriceEvent = `${pairPrefix}_${SOCKET.LAST_TRADE_PRICE}`;

    const onTrade = (trade) => {
      dispatch(setLastTrade(trade));
      dispatch(setLastPrice(trade?.price));
    };

    const onLastTradePrice = (payload) => {
      const price =
        payload != null && typeof payload === "object"
          ? payload.price
          : payload;
      if (price != null && price !== "") {
        dispatch(setLastPrice(price));
      }
    };

    const pairTopic = pairPrefix.toLowerCase();

    const onGlobalLastTradePrice = (payload) => {
      if (!payload || typeof payload !== "object") return;
      const socketPair = String(payload.pair ?? "").trim().toLowerCase();
      if (socketPair && socketPair !== pairTopic) return;
      onLastTradePrice(payload);
    };

    socket.on(tradeEvent, onTrade);
    socket.on(lastTradePriceEvent, onLastTradePrice);
    socket.on(SOCKET.LAST_TRADE_PRICE, onGlobalLastTradePrice);
    console.log("[SocketHook] listening", {
      pair_key: selectedPair.pair_key,
      events: [tradeEvent, lastTradePriceEvent, SOCKET.LAST_TRADE_PRICE],
    });

    return () => {
      socket.off(tradeEvent, onTrade);
      socket.off(lastTradePriceEvent, onLastTradePrice);
      socket.off(SOCKET.LAST_TRADE_PRICE, onGlobalLastTradePrice);
    };
  }, [selectedPair?.pair_key, dispatch]);
};
